import React from "react";
import "../../../../../styles/Pages/Financial/CashInFlow/Fees/FeeReceipt.style.css";
const FeeReceipt = () => {
  const receiptData = {
    receiptId: "23457289056",
    dateTime: "10:30 AM, 02 Oct, 2025",
    studentName: "Toufik Alam",
    studentId: "SM0523019",
    class: "5/B",
    contact: "9876543210",
    address: "abc village, abc block, abc district, abc state, 722027",
    purposeCategory: "Admission fees",
    subCategories: [
      { description: "1. Room rent", amount: 900 },
      { description: "2. Food facilities", amount: 700 },
      { description: "3. Software charges", amount: 120 },
    ],
    subTotal: 1720,
    otherTax: 309.6,
    total: 2029.6,
    paymentMode: "Net banking",
    eSign: "Jahir Ahmad",
  };

  return (
    <div className="receipt-container">
      <div className="receipt-header box">
        {/* <div className="fee-label corner-label"><span>FEES</span></div> */}
        <div className="school-name">
          <div className="school-logo">Logo</div>
          <h3>Elementary School of Business and Social Sciences</h3>
        </div>
        <div className="receipt-details">
          <span>
            <span className="title">Receipt ID:</span> {receiptData.receiptId}
          </span>
          <span>
            <span className="title">Date & time:</span> {receiptData.dateTime}
          </span>
        </div>
      </div>
      <div className="student-details">
        <div className="first-column">
          <strong id="studentName">{receiptData.studentName}</strong>
          <br />
          <span id="studentId">#{receiptData.studentId}</span>
        </div>
        <div className="second-column">
          <span>
            <strong id="class">Class:</strong> {receiptData.class}
          </span>
          <span>
            <strong id="contact">Contact:</strong> {receiptData.contact}
          </span>
        </div>
        <div className="third-column">
          <strong id="address">Address:</strong> {receiptData.address}
        </div>
      </div>
      <div className="fee-breakdown">
        <table>
          <thead>
            <tr>
              <th>Purpose category</th>
              <th>Purpose subcategory</th>
              <th>Amount (INR)</th>
            </tr>
          </thead>
          <tbody>
            {receiptData.subCategories.map((item, index) => (
              <tr
                className={`${
                  receiptData.subCategories.length - 1 === index ? "last" : ""
                }`}
                key={index}
              >
                <td>{index === 0 ? receiptData.purposeCategory : ""}</td>
                <td>{item.description}</td>
                <td>₹{item.amount}</td>
              </tr>
            ))}
            <tr id="subTotal">
              <td colSpan="2">Sub total:</td>
              <td>₹{receiptData.subTotal}</td>
            </tr>
            <tr id="taxes">
              <td colSpan="2">Other tax (GST, SGST, CGST):</td>
              <td>₹{receiptData.otherTax}</td>
            </tr>
            <tr id="total">
              <td colSpan="2">Total:</td>
              <td>₹{receiptData.total}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="school-logo-bottom"></div>
      <div className="payment-details">
        <div>
          <strong id="paymentMode">Payment mode:</strong>{" "}
          {receiptData.paymentMode}
        </div>
        <div>
          <strong id="eSign">E-Sign by:</strong> {receiptData.eSign}
        </div>
      </div>
      <div className="footer">
        <span>Official seal</span>
        <span>Authorised signatory</span>
      </div>
    </div>
  );
};

export default FeeReceipt;
